import { makeStyles } from "@material-ui/core/styles";

const loaderDot = {
    animation: "$toggle 0.6s linear infinite",
    fontWeight: 500,
    fontSize: "1.2rem"
};

export default makeStyles((theme) => ({
    dialogPaper: {
        width: "100%",
        height: "100%",
    },
    contentRoot: {
        display: "flex",
        gap: "20px",
        height: "100%",
    },
    contentSection: {
        overflow: "auto",
        width: "50%",
        padding: "10px",
        boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
        borderRadius: "4px",
        backgroundColor: "#FAFAFA"
    },
    droppable: {
        display: "flex",
        overflowX: "auto",
        width: "100%",
        justifyContent: "flex-start",
        gap: "40px",
        height: "16rem",
        alignContent: "center",
        boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 2px 1px inset",
        backgroundColor: "#E2E6EE",
        borderRadius: "4px",
        borderTopLeftRadius: 0,
        padding: "10px 20px"
    },
    draggable: {
        height: "100%"
    },
    previewImage: {

    },
    iconButton: {
        border: "1px solid #ccc",
        borderRadius: "4px",
        padding: "6px"
    },
    invoiceIndexBox: {
        height: "30px",
        padding: "0 6px",
        minWidth: "25px",
        color: theme.palette.primary.main,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "4px 0 0 4px",
        border: "2px solid #D2D6DE",
        borderRight: "none",
        fontWeight: 500
    },
    pagesCountChip1: {
        borderRadius: "4px 0 0 4px",
    },
    pagesCountChip2: {
        borderRadius: "4px",
    },
    invoicesCountChip: {
        borderLeft: "2px solid white",
        borderRadius: "0 4px 4px 0",
    },
    statusChip: {
        border: "none",
        "& .MuiChip-iconColorPrimary": {
            color: theme.palette.secondary.main
        }
    },
    rotateIcon: {
        animation: "$spin 3s linear infinite"
    },
    "@keyframes spin": {
        "0%": {
            transform: "rotate(0deg)"
        },
        "100%": {
            transform: "rotate(360deg)"
        }
    },
    loader: {
        position: "absolute",
        top: "calc(50% - 50px)",
        left: "calc(50% - 50px)",
        padding: "20px",
        color: theme.palette.primary.main
    },
    loaderDot1: {
        ...loaderDot,
        animationDelay: "0s",
    },
    loaderDot2: {
        ...loaderDot,
        animationDelay: "0.2s",
    },
    loaderDot3: {
        ...loaderDot,
        animationDelay: "0.4s",
    },
    "@keyframes toggle": {
        "0%": {
            opacity: 1
        },
        "100%": {
            opacity: 0
        }
    },
}));
